import { FirebaseOptions } from '@firebase/app';

import { isProduction } from 'helpers/environment';

const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string;

const getFirebaseConfig = (): FirebaseOptions => {
  if (isProduction) {
    return {
      apiKey,
      authDomain: 'sidejuice-production.firebaseapp.com',
      projectId: 'sidejuice-production',
      storageBucket: 'sidejuice-production.firebasestorage.app',
      messagingSenderId: '1058327817999',
      appId: '1:1058327817999:web:7381ddf0b5f7dfd9d3587a',
      measurementId: 'G-0PHLWJDSD2',
    };
  }

  return {
    apiKey,
    authDomain: 'sidejuice-dev.firebaseapp.com',
    projectId: 'sidejuice-dev',
    storageBucket: 'sidejuice-dev.firebasestorage.app',
    messagingSenderId: '522261853853',
    appId: '1:522261853853:web:93ed67fb06e153fcb54674',
  };
};

const firebaseConfig = getFirebaseConfig();
export default firebaseConfig;
